import styles from './resetpasswordskeleton.module.css';
import { Skeleton } from "../../../../shared/ui/Skeleton";


export function ResetPasswordSkeleton() {
    return (
        <div className={styles.skeletonWrapper}>
            <Skeleton height={40} width={'100%'} />
            <Skeleton height={40} width={'100%'} />
        </div>
    )
}